import { useElementSize, useViewportSize } from '@mantine/hooks';

import styles from './PrintLetterPreview.module.scss';

/** PostGrid letter pages are 8.5×11in at 96dpi. */
export const LETTER_PAGE_WIDTH = 816;
export const LETTER_PAGE_HEIGHT = 1056;
/** Padding around the sheet in .previewViewport, both sides. */
const VIEWPORT_PADDING = 24;

interface PrintLetterPreviewProps {
  html: string;
  title: string;
}

/**
 * The filled letter, scaled down so the whole page fits. Sandboxed with no permissions:
 * nothing in the template can run script or reach this page.
 */
const PrintLetterPreview = ({ html, title }: PrintLetterPreviewProps) => {
  const { ref, width } = useElementSize<HTMLDivElement>();
  const { height: viewportHeight } = useViewportSize();
  const maxHeight = Math.max(320, (viewportHeight || 900) * 0.68);
  const fitWidth = width > 0 ? (width - VIEWPORT_PADDING) / LETTER_PAGE_WIDTH : 0.5;
  const scale = Math.max(0.2, Math.min(fitWidth, maxHeight / LETTER_PAGE_HEIGHT, 1));

  return (
    <div ref={ref}>
      <div className={styles.previewViewport}>
        <div
          className={styles.previewSheet}
          style={{ width: LETTER_PAGE_WIDTH * scale, height: LETTER_PAGE_HEIGHT * scale }}>
          <iframe
            title={title}
            sandbox=""
            srcDoc={html}
            className={styles.previewPage}
            style={{ transform: `scale(${scale})` }}
          />
        </div>
      </div>
    </div>
  );
};

export default PrintLetterPreview;
